import "apps/pathways/styles/app/main/pathway.scss";
import React from 'react';
import Masthead from 'apps/pathways/components/pathways/masthead';
import Sections from 'apps/pathways/components/sections';
import PathwaysFooter from 'apps/pathways/components/pathways-footer';
import withUser from 'util/hoc/with-user';
const SectionsWithUser = withUser(Sections);

export default class Pathway extends React.Component {
  render() {
    return (
      <div className="pathway">
        <Masthead changePathway={this.props.changePathway} data={this.props.data} />
        <SectionsWithUser data={this.props.data} />
        <PathwaysFooter />
      </div>
    )
  }
}
